import React from "react";
import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/utils/hooks/useDocumentTitle";

const modules = [
  {
    to: "/info-tagihan",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    title: "Info Tagihan",
    description:
      "Cek informasi tagihan air Anda, riwayat pembayaran, dan status tagihan secara mudah dan cepat.",
    color: "bg-blue-50 text-[#095393]",
    btnColor: "bg-[#095393] hover:bg-[#074a7a]",
  },
  {
    to: "/registrasi-pelanggan",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
        />
      </svg>
    ),
    title: "Registrasi Pelanggan",
    description:
      "Daftarkan diri Anda sebagai pelanggan baru layanan air minum Perumda Air Minum Cilegon Mandiri.",
    color: "bg-green-50 text-green-700",
    btnColor: "bg-green-600 hover:bg-green-700",
  },
  {
    to: "/pengaduan",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
        />
      </svg>
    ),
    title: "Pengaduan",
    description:
      "Sampaikan pengaduan, saran, atau laporan terkait layanan air minum kepada kami secara anonim.",
    color: "bg-orange-50 text-orange-600",
    btnColor: "bg-orange-500 hover:bg-orange-600",
  },
];

function Home() {
  useDocumentTitle("Beranda - Perumda Air Minum Cilegon Mandiri");

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-[#095393] overflow-hidden w-screen z-0"
        style={{
          marginLeft: "calc(50% - 50vw)",
          marginRight: "calc(50% - 50vw)",
          width: "100vw",
          maxWidth: "100vw",
        }}
      >
        <div className="absolute bottom-0 left-0 right-0">
          <svg
            className="w-full h-16 md:h-24"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,60 C300,100 600,20 900,60 C1050,80 1150,40 1200,60 L1200,120 L0,120 Z"
              fill="white"
              opacity="0.3"
            />
            <path
              d="M0,80 C300,120 600,40 900,80 C1050,100 1150,60 1200,80 L1200,120 L0,120 Z"
              fill="white"
              opacity="0.5"
            />
            <path
              d="M0,100 C300,140 600,60 900,100 C1050,120 1150,80 1200,100 L1200,120 L0,120 Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">
              Layanan Digital Pelanggan
            </h1>
            <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto">
              Perumda Air Minum Cilegon Mandiri — akses layanan pelanggan kapan
              saja dan di mana saja.
            </p>
          </div>
        </div>
      </div>

      {/* Modules Section */}
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8 -mt-8 md:-mt-12 relative z-20 pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {modules.map((mod) => (
            <div
              key={mod.to}
              className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col items-center text-center hover:shadow-lg transition-shadow"
            >
              <div className={`p-4 rounded-full mb-4 ${mod.color}`}>
                {mod.icon}
              </div>
              <h2 className="text-lg font-bold text-gray-800 mb-2">
                {mod.title}
              </h2>
              <p className="text-gray-500 text-sm flex-1 mb-5">
                {mod.description}
              </p>
              <Link
                to={mod.to}
                className={`w-full text-center text-white font-semibold py-2.5 px-4 rounded-lg transition-colors ${mod.btnColor}`}
              >
                Akses Layanan
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Home;
